import axios from 'axios';
import CryptoJS from 'crypto-js';
import {store, history} from '../redux/store';
import {UserLogin} from '../modules/auth/actions';

export const apibase = 'https://rest_athens.key4.com.ua';//'https://athens-dev.key4.com.ua';//

export function decryptRandomNumber(pwdHash, encryptedRandom) {
    const iv = CryptoJS.enc.Hex.parse('00000000000000000000000000000000');
    const key = CryptoJS.enc.Utf8.parse(pwdHash);
    const encrypted = CryptoJS.enc.Hex.parse(encryptedRandom.toUpperCase());

    return CryptoJS.AES.decrypt({
        ciphertext: encrypted
    }, key, {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
    }).toString(CryptoJS.enc.Utf8);
}

export function encryptPwdHash(pwdHash, randomNumber) {
    const iv = CryptoJS.enc.Hex.parse('00000000000000000000000000000000');
    const randomNumberMd5 = CryptoJS.MD5(randomNumber).toString().toUpperCase();
    const key = CryptoJS.enc.Utf8.parse(randomNumberMd5);

    return CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(pwdHash), key, {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
    }).ciphertext;
}

/**
 * Add auth token to each request
 * @param token
 */
export function setAuthToken(token) {
    if (token) {
        axios.defaults.headers.common['Authorization'] = token;
    } else {
        delete axios.defaults.headers.common['Authorization'];
    }
}

/**
 * Send data to API
 * @param path API endpoint
 * @param params API params
 * @param method API HTTP Verb
 * @return Promise
 */
function request(path, params = {}, method = 'get', raw = false) {
    return axios[method](apibase + path, params)
        .then(
            data => {
                // console.log(data);
                if (typeof data.data === 'string' && !raw) {
                    data.data = JSON.parse(data.data.replace(/\r\n/g, ""));
                }
                if (data.data.returnCode !== undefined && data.data.returnCode !== 1) {
                    return Promise.reject(data);
                }

                return data;
            },
            error => {
                const auth = store.getState().auth;

                if (error.response && (error.response.status >= 400 || error.response.status < 500)) {
                    // console.log('seems that i was logged out. removing default token');
                    setAuthToken(null);
                    if (auth.remember && auth.isAuthenticated) {
                        return store.dispatch(
                            UserLogin(
                                auth.credentials.login,
                                auth.credentials.pwdHash,
                                auth.remember, () => {
                                    history.push('/logout');
                                }
                            )
                        ).then(
                            () => {
                                return request(path, params, method);
                            }
                        );
                    } else {
                        return Promise.reject(error);
                    }
                } else if (error.response === undefined) {
                    ///// CURRENTLY HACK PLZ REWORK SOMEDAY
                    const changing = store.getState().dialog.changing;
                    const nextPayload = {
                        type: 'DIALOG_EVENT',
                        payload: {
                            changing,
                            show: false,
                        }
                    };
                    store.dispatch({
                        type: 'DIALOG_EVENT',
                        payload: {
                            changing,
                            show: true,
                            yes: () => {
                                store.dispatch(nextPayload);
                            },
                            noTitle: null,
                            yesTitle: 'OK',
                            body: 'Возникла ошибка при соедиенении с сервером, проверьте интернет-соединение!',
                            title: 'Ошибка!'
                        }
                    });
                }

                return Promise.reject(error);
            }
        );
}

export default request;



/** WEBPACK FOOTER **
 ** ./src/api/api.js
 **/